// Loan configuration
export const LOAN_CONFIG = {
  MIN_AMOUNT: 1000,
  MAX_AMOUNT: 500000, 
  AMOUNT_STEP: 1000,
  MIN_DURATION: 6, // months
  MAX_DURATION: 120, // 
  DURATION_STEP: 6, // 6 months increments
  INTEREST_RATE: 0.03, // 3% annual interest rate
};

// Contact information
export const CONTACT = {
  WHATSAPP_NUMBER: process.env.REACT_APP_WHATSAPP_NUMBER || '358469625279',
  SUPPORT_EMAIL: process.env.REACT_APP_SUPPORT_EMAIL || 'juhanenonen2@gmail.com',
};

// Validation rules
export const VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE_MIN_LENGTH: 8,
  PHONE_MAX_LENGTH: 15,
};

// Storage keys
export const STORAGE_KEYS = {
  LOAN_DRAFT: 'donexa_loan_draft',
  LANGUAGE: 'donexa_language',
};

// Application routes
export const ROUTES = {
  HOME: '/',
  LEGAL: '/legal',
  TERMS: '/terms',
  PRIVACY: '/privacy',
  ABOUT: '/about',
};